module.exports = __webpack_public_path__ + "img/5.e97644e0.png";